import {i18n_get_TODO} from '@appscience/utils'
import {Button, Dialog, TextInput} from '@mantine/core'
import {useEffect, useRef, useState} from 'react'
import {SearchDialogProps} from './model'

export function SearchDialog({
  show,
  onClose,
  onSearch,
  placeholder,
  position,
}: SearchDialogProps) {
  return (
    <Dialog
      opened={show}
      onClose={onClose}
      position={position}
      size='lg'
      radius='md'
      zIndex={10}
      withCloseButton
    >
      <Content onSearch={onSearch} placeholder={placeholder} />
    </Dialog>
  )
}

interface ContentProps {
  onSearch: (v: string) => void,
  placeholder?: string,
}

function Content({
  onSearch,
  placeholder,
}: ContentProps) {
  const inputRef = useRef<HTMLInputElement>(null)
  const [value, setValue] = useState('')
  const onApply = () => onSearch(value)

  useEffect(() => {
    //Чтобы фокус сохранялся и при открытии по клику, а не только при открытии по hotKey
    setTimeout(() => inputRef.current?.focus(), 0)
  }, [])

  return (
    <>
      <div className='font-medium mb-2.5'>
        {i18n_get_TODO('Search')}
      </div>

      <div className='flex'>
        <TextInput
          onKeyDown={event => {
            if (event.code === 'Enter') {
              event.preventDefault()
              inputRef.current?.blur()
              onApply()
            }
          }}
          ref={inputRef}
          className='grow mr-2.5'
          value={value}
          onChange={event => setValue(event.currentTarget.value)}
          placeholder={placeholder}
        />
        <Button px={20} onClick={onApply}>{i18n_get_TODO('Find')}</Button>
      </div>
    </>
  )
}